import { TEMP_HACK_REMOVE } from '../../account-configurations/utils/TEMP_HACK_REMOVE';

const ID_MAPPING = {
    'app.campaigns.reports.grid.column.header.message.visibleImpressions':
        'app.campaigns.reports.grid.column.header.message.impressions',
    'app.campaigns.reports.grid.column.header.message.impressions':
        'app.campaigns.reports.grid.column.header.impressionsToServedAds',
    'app.campaigns.reports.grid.column.header.message.vctr': 'app.campaigns.reports.grid.column.header.message.ctr',
    'app.campaigns.reports.grid.column.header.message.vcpm': 'app.campaigns.reports.grid.column.header.message.cpm',
    'app.campaigns.reports.grid.column.header.tooltip.header.visibleImpressions':
        'app.campaigns.reports.grid.column.header.message.impressions',
    'app.campaigns.reports.grid.column.header.tooltip.content.visibleImpressions':
        'app.campaigns.reports.grid.column.header.tooltip.content.visibleImpressionsToImpression',
    'app.campaigns.reports.grid.column.header.tooltip.header.vctr':
        'app.campaigns.reports.grid.column.header.message.ctr',
    'app.campaigns.reports.grid.column.header.tooltip.content.vctr':
        'app.campaigns.reports.grid.column.header.tooltip.content.vctrToCtr',
    'app.campaigns.reports.grid.column.header.tooltip.header.vcpm':
        'app.campaigns.reports.grid.column.header.message.cpm',
    'app.campaigns.reports.grid.column.header.tooltip.content.vcpm':
        'app.campaigns.reports.grid.column.header.tooltip.content.vcpmToCpm',
    'app.campaigns.reports.grid.column.header.tooltip.header.impressions':
        'app.campaigns.reports.grid.column.header.impressionsToServedAds',
    'app.campaigns.reports.grid.column.header.tooltip.content.impressions':
        'app.campaigns.reports.grid.column.header.tooltip.content.impressionsToServedAds',
    'campaign.reach.estimator.widget.title': 'campaign.reach.estimator.widget.title.impressions',
    'campaign.reach.estimator.widget.tooltip.message.text':
        'campaign.reach.estimator.widget.tooltip.message.text.impressions',
    'campaign.reach.estimator.widget.description.text': 'campaign.reach.estimator.widget.description.text.impressions',
    'performance.rule.create.settings.metric.name.VISIBLE_IMPRESSIONS':
        'performance.rule.create.settings.metric.name.IMPRESSIONS',
    'performance.rule.create.settings.metric.name.VCTR': 'performance.rule.create.settings.metric.name.CTR',
    'performance.rule.create.settings.metric.name.IMPRESSIONS':
        'performance.rule.create.settings.metric.name.IMPRESSIONSToServedAds',
    'campaign.reach.estimator.widget.small.reach.warning.text':
        'campaign.reach.estimator.widget.small.reach.warning.text.impressions',
    'audience.creator.combined.audiences.reach.estimator.widget.small.reach.warning.text':
        'audience.creator.combined.audiences.reach.estimator.widget.small.reach.warning.text.impressions',
    'app.campaigns.reports.grid.column.header.message.uniqueImpressions':
        'app.campaigns.reports.grid.column.header.message.impressionsToUniqueServedAdsReach',
    'app.campaigns.reports.grid.column.header.tooltip.header.uniqueImpressions':
        'app.campaigns.reports.grid.column.header.message.impressionsToUniqueServedAdsReach',
    'app.campaigns.reports.grid.column.header.message.uniqueViewableImpressions':
        'app.campaigns.reports.grid.column.header.message.uniqueImpressions',
    'app.campaigns.reports.grid.column.header.tooltip.header.uniqueViewableImpressions':
        'app.campaigns.reports.grid.column.header.message.uniqueImpressions',
    'app.campaigns.reports.grid.column.header.tooltip.content.uniqueImpressions':
        'app.campaigns.reports.grid.column.header.tooltip.content.uniqueImpressions.impressionsToUniqueServedAdsReach',
    'campaign.editor.thirdPartyTags.eventType.VIEWABLE_IMPRESSION':
        'campaign.editor.thirdPartyTags.eventType.IMPRESSION',
    'campaign.editor.thirdPartyTags.eventType.IMPRESSION':
        'campaign.editor.thirdPartyTags.eventType.ImpressionToServedAds',
    'creative.editor.thirdPartyTags.eventType.VIEWABLE_IMPRESSION':
        'creative.editor.thirdPartyTags.eventType.IMPRESSION',
    'creative.editor.thirdPartyTags.eventType.IMPRESSION':
        'creative.editor.thirdPartyTags.eventType.IMPRESSION.ImpressionToServedAds',
    'app.campaigns.reports.grid.column.header.message.ctr':
        'app.campaigns.reports.grid.column.header.message.ctr.ToServedAds',
    'app.campaigns.reports.grid.column.header.message.cpm':
        'app.campaigns.reports.grid.column.header.message.cpm.ToServedAds',
    'app.campaigns.reports.grid.column.header.tooltip.content.ctr':
        'app.campaigns.reports.grid.column.header.tooltip.content.ctr.ToCtrServedAds',
    'app.campaigns.reports.grid.column.header.tooltip.content.cpm':
        'app.campaigns.reports.grid.column.header.tooltip.content.cpm.ToCpmServedAds',
    'app.campaigns.reports.filters.type.visible_impressions':
        'app.campaigns.reports.filters.type.visible_impressions_to_impressions',
    'app.campaigns.reports.filters.type.impressions': 'app.campaigns.reports.filters.type.impressionsToServedAds',
    'app.campaigns.reports.filters.type.vctr': 'app.campaigns.reports.filters.type.vctrToCtr',
    'app.campaigns.reports.filters.type.vcpm': 'app.campaigns.reports.filters.type.vcpmToCpm',
};

// todo: remove this hack DEV-183569
export const TEMP_HACK_REMOVE_ID = id => {
    const alignDefinitions = TEMP_HACK_REMOVE.getValue();
    if (!alignDefinitions) {
        return id;
    }

    return ID_MAPPING[id] ? ID_MAPPING[id] : id;
};
